export default function Marquee({ items, dark = false }) {
  const content = [...items, ...items];
  return (
    <div
      className={`w-full overflow-hidden border-y-2 py-5 ${
        dark ? "border-[#F6F1E8]/25 bg-[#14283A]" : "border-[#14283A] bg-[#F6F1E8]"
      }`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {content.map((it, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span
              className={`font-display text-3xl sm:text-5xl ${
                dark ? "text-outline-sable" : "text-outline-navy"
              }`}
            >
              {it}
            </span>
            <span className="grad-text font-marker text-2xl sm:text-4xl">✷</span>
          </span>
        ))}
      </div>
    </div>
  );
}
